// Valores ancorados em 1300 (o mesmo z-index que o MUI usa por padrão pra
// modais, theme.zIndex.modal) — o app não tem um MUI ThemeProvider real
// configurado, então não dá pra referenciar theme.zIndex.modal diretamente,
// mas a convenção de valor é a mesma. Antes esses valores eram só 1-6, o que
// perdia de qualquer z-index do layout (header=30, sidebar=40, drawer=91).
export enum ModalPriorityEnum {
  VERY_LOW = 1301,
  LOW = 1302,
  MEDIUM = 1303,
  HIGH = 1304,
  VERY_HIGH = 1305,
  CRITICAL = 1306,
}